import { HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiGateway } from '@sb/shared/api';
import { IGNORE_META_ERROR_MESSAGE } from '@sb/shared/util';

import { AddonOfferEligibility } from './addon-offer.model';

@Injectable({ providedIn: 'root' })
export class AddonOfferApiService {
  #gateway = inject(ApiGateway);

  // Callers fall back to sales on any failure, so a toast would only add noise.
  eligibility(offerKey: string) {
    return this.#gateway.get<AddonOfferEligibility>(`addon-offers/${offerKey}`, {
      context: new HttpContext().set(IGNORE_META_ERROR_MESSAGE, true),
    });
  }

  claim(offerKey: string) {
    return this.#gateway.post<void>(`addon-offers/${offerKey}/claim`, {});
  }
}
